"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_overlay_1 = require("@hopin-team/ui-overlay");

var react_1 = tslib_1.__importDefault(require("react"));

var contents_1 = require("./partials/contents");

var root_1 = require("./styled/root");

var defaultRenderOverlay = function defaultRenderOverlay(props) {
  return react_1.default.createElement(ui_overlay_1.Overlay, tslib_1.__assign({}, props));
};

var renderRoot = function renderRoot(rootClasses, restProps, children) {
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses
  }, react_1.default.createElement(contents_1.Contents, tslib_1.__assign({}, restProps), children));
};

var Modal = function Modal(_a) {
  var children = _a.children,
      className = _a.className,
      isShowing = _a.isShowing,
      _b = _a.renderOverlay,
      renderOverlay = _b === void 0 ? defaultRenderOverlay : _b,
      __UIScope = _a.__UIScope,
      restProps = tslib_1.__rest(_a, ["children", "className", "isShowing", "renderOverlay", "__UIScope"]);

  var _c = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: Modal.name,
    className: className,
    __UIScope: __UIScope
  }),
      makeClasses = _c.makeClasses,
      rootClasses = _c.rootClasses;

  if (!isShowing) {
    return null;
  }

  return renderOverlay({
    children: renderRoot(rootClasses, restProps, children),
    className: makeClasses('Overlay'),
    isFullScreen: true
  });
};

exports.Modal = Modal;